// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/blue-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/Images/zap.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-info-mobile {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  background: #f3f5f7;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  margin-top: 40px;
}
.payment-info-mobile .stripe-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.payment-info-mobile .stripe-elements {
  display: flex;
  flex-direction: column;
  margin: 10vh 0;
  justify-content: center;
  padding: 20px;
  width: 40%;
  border-radius: 24px;
  background: #FEFEFE;
  box-shadow: 0px 40px 64px -16px rgba(0, 0, 0, 0.15), 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}
.payment-info-mobile .stripe-elements .plan-opt {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 50px;
}
.payment-info-mobile .plan-discriminator {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-right: 50px;
  width: 250px;
  padding-top: 140px;
}
.payment-info-mobile .plan-discriminator .plan-container {
  font-weight: 600;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.payment-info-mobile .plan-discriminator .plan-container .plan-badge {
  font-size: 12px;
  line-height: 24px;
  background-color: #ff97e8;
  color: #141718;
  width: 68px;
  height: 24px;
  padding: 0px 12px 0px 12px;
  border-radius: 4px;
  gap: 8px;
}
.payment-info-mobile .plan-discriminator .plan-section {
  display: flex;
  flex-direction: row;
}
.payment-info-mobile .plan-discriminator .plan-section .plan-price {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: center;
  margin-right: 20px;
}
.payment-info-mobile .plan-discriminator .plan-section .plan-periodicity {
  color: #6c7275;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: center;
}
.payment-info-mobile .plan-discriminator .divider {
  border-top: 1px solid rgba(0, 0, 0, 0.1019607843);
  margin: 15px 0px;
}
.payment-info-mobile .plan-discriminator .plan-benefits-icon {
  color: #0084ff;
  padding-right: 10px;
  display: block;
  padding-top: 4px;
}
.payment-info-mobile .plan-discriminator .plan-benefits-icon .svg-inline--fa {
  height: 20px;
}
.payment-info-mobile .plan-discriminator .plan-benefits-text {
  color: #141718;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: left;
}
.payment-info-mobile .plan-lock {
  color: #0c923c;
  margin-right: 10px;
}
.payment-info-mobile .pay-resume {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.payment-info-mobile .pay-resume .pay-resume-text {
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
}
.payment-info-mobile .no-margin-bottom {
  margin-bottom: 0;
}
.payment-info-mobile .promo-container {
  display: flex;
  flex-direction: column;
}
.payment-info-mobile .pay-promocode {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.payment-info-mobile .pay-promocode .button-link {
  display: flex;
  flex-direction: row-reverse;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: right;
  text-decoration: none;
}
.payment-info-mobile .pay-promocode .pay-resume-text {
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
}
.payment-info-mobile .pay-text {
  margin-bottom: 20px;
  font-size: 11px;
  width: 100% !important;
  color: #B6B8B9;
  padding: 20px;
}
.payment-info-mobile .pay-btn {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.payment-info-mobile .pay-btn button {
  font-size: 15px;
  font-weight: 600;
  padding: 8px 20px;
  border-radius: 12px;
  width: 100%;
  height: 52px;
}
.payment-info-mobile .plan-lock-instruction {
  color: #6c7275;
  font-size: 12px;
}
.payment-info-mobile .paymentinfo-option {
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #000;
}
.payment-info-mobile .paymentinfo-option.best-option {
  color: #fff;
  background-color: #000;
}
.payment-info-mobile .paymentinfo-option .paymentinfo-periodicity {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: rgba(108, 114, 117, 0.5);
}
.payment-info-mobile .paymentinfo-option .popular-opt {
  gap: 8px;
  background: #ff97e8;
  border-radius: 4px;
  color: #141718;
}
.payment-info-mobile .paymentinfo-opt {
  list-style-type: none;
}
.payment-info-mobile .periodicity-opt {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.item-plan {
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: row;
  margin-bottom: 4px;
}

.selected-plan .plan-name {
  color: #139843;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
}

.mobile-plan-top {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;
}

.container {
  --bs-gutter-x: 0 !important;
}

.mobile-view .plan-discriminator {
  width: 90%;
  margin: 0 auto !important;
  padding: 0;
  padding-top: 0 !important;
}

.mobile-view .plan-discriminator .item-plan {
  display: none;
}

.mobile-view .plan-discriminator .plan-section {
  margin: 4px auto;
}

.mobile-view .plan-discriminator .plan-section .plan-price {
  color: #6c7275;
  font-size: 14px;
  margin-right: 6px;
  font-weight: 400;
}

.mobile-view .plan-discriminator .plan-section .plan-periodicity {
  color: #6c7275;
  font-size: 14px;
  font-weight: 400;
}

.mobile-view .plan-discriminator .selected-plan {
  background-color: #141718;
  border-radius: 25px;
  width: 100%;
  display: flex;
  padding: 10px 20px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.mobile-view .plan-discriminator .plan-name {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 30px;
  background-position: left;
  color: #3FDD78;
  padding-left: 40px;
  font-size: 20px;
}

.mobile-view .plan-discriminator .selected-plan .rectangle {
  background-color: #FF69B4;
  color: #000;
  border-radius: 20px;
}

.mobile-view .selected-plan-badge {
  border: solid 1px #000;
  padding: 4px 8px;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  width: 120px;
  text-align: center;
  margin: -1px auto;
  font-size: 12px;
  font-weight: 600;
}

.payment-info .stripe-elements {
  margin-top: 20px !important;
}

.mobile-view .payment-secured {
  margin: 0px auto 10px auto;
}

.mobile-view .periodicity-opt {
  display: flex;
  align-content: center;
  align-items: stretch;
  justify-content: space-between;
  flex-direction: row !important;
}

.mobile-view .periodicity-container .periodicity-pay-text {
  display: flex;
  flex-direction: row !important;
  position: relative;
  font-size: 12px;
  font-weight: 600;
}

.mobile-view .periodicity-container {
  padding: 10px !important;
  position: relative;
}

.mobile-view .periodicity-container .periodicity-pay-text .periodicity-save {
  background-color: #000;
  font-size: 10px;
  padding: 2px 6px;
  color: #FEFEFE;
  width: fit-content;
  height: fit-content;
}

.mobile-view .periodicity-pay-specifics .price {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #000;
}

.mobile-view .periodicity-pay-specifics .per-period {
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #6F6F6F;
}

.mobile-view .form-control {
  height: 52px;
  border-radius: 12px;
  border-color: #6F6F6F;
}

body .mobile-view .form-control .__PrivateStripeElement {
  top: 10px !important;
}

.mobile-view .pay-resume {
  background-color: #DEEBFF;
  text-align: center;
  border-radius: 30px;
  color: #000;
  display: flex;
  padding: 16px 20px;
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin: 0 auto 20px;
}

.mobile-view .pay-resume .pay-resume-text {
  color: #141718;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/Components/PaymentInfoMobile/PaymentInfoMobile.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,4BAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,wFAAA;AAAJ;AAEI;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;AAAN;AAIE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAFJ;AAII;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;AAFN;AAKM;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EAEA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,QAAA;AAJR;AAQI;EACE,aAAA;EACA,mBAAA;AANN;AAQM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AANR;AASM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;AAPR;AAWI;EACE,iDAAA;EACA,gBAAA;AATN;AAYI;EACE,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAVN;AAaI;EACE,YAAA;AAXN;AAcI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAZN;AAgBE;EACE,cAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAfN;AAmBE;EACE,gBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,sBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,aAAA;EACA,2BAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;AApBN;AAuBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AArBN;AAyBE;EAEE,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA1BJ;AA6BE;EACE,cAAA;EACA,eAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AA5BJ;AA8BI;EACE,WAAA;EACA,sBAAA;AA5BN;AA+BI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,+BAAA;AA7BN;AAgCI;EACE,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AA9BN;AAkCE;EACE,qBAAA;AAhCJ;AAmCE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAjCJ;;AAqCA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AAlCF;;AAqCA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAlCF;;AAuCA;EACE,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,+BAAA;AApCF;;AAuCA;EACE,2BAAA;AApCF;;AA0CA;EACE,UAAA;EACA,yBAAA;EACA,UAAA;EACA,yBAAA;AAvCF;;AA0CA;EACE,aAAA;AAvCF;;AA0CA;EACE,gBAAA;AAvCF;;AAyCA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAtCF;;AAwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AArCF;;AAwCA;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AArCF;;AAwCA;EACE,mDAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AArCF;;AAwCA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;AArCF;;AAuCA;EACE,sBAAA;EACA,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AApCF;;AAuCA;EACE,2BAAA;AApCF;;AAuCA;EACE,0BAAA;AApCF;;AAuCA;EACE,aAAA;EACA,qBAAA;EACA,oBAAA;EACA,8BAAA;EACA,8BAAA;AApCF;;AAuCA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AApCF;;AAuCA;EACE,wBAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AApCF;;AAuCA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AApCF;;AAuCA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AApCF;;AAuCA;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;AApCF;;AAuCA;EACE,oBAAA;AApCF;;AAuCA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AApCF;;AAuCA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AApCF","sourcesContent":[".payment-info-mobile {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  background: #f3f5f7;\n  border-top-right-radius: 20px;\n  border-top-left-radius: 20px;\n  margin-top: 40px;\n\n  .stripe-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  }\n\n  .stripe-elements {\n    display: flex;\n    flex-direction: column;\n    margin: 10vh 0;\n    justify-content: center;\n    padding: 20px;\n    width: 40%;\n    border-radius: 24px;\n    background: #FEFEFE;\n    box-shadow: 0px 40px 64px -16px rgba(0, 0, 0, 0.15), 0px 0px 4px 0px rgba(0, 0, 0, 0.05);\n\n    .plan-opt {\n      list-style-type: none;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: space-around;\n      margin-bottom: 50px;\n    }\n  }\n\n  .plan-discriminator {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    padding-right: 50px;\n    width: 250px;\n    padding-top: 140px;\n\n    .plan-container {\n      font-weight: 600;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: space-between;\n      align-items: center;\n\n\n      .plan-badge {\n        font-size: 12px;\n        line-height: 24px;\n        background-color: #ff97e8;\n        color: #141718;\n\n        width: 68px;\n        height: 24px;\n        padding: 0px 12px 0px 12px;\n        border-radius: 4px;\n        gap: 8px;\n      }\n    }\n\n    .plan-section {\n      display: flex;\n      flex-direction: row;\n\n      .plan-price {\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 24px;\n        letter-spacing: -0.02em;\n        text-align: center;\n        margin-right: 20px;\n      }\n\n      .plan-periodicity {\n        color: #6c7275;\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 24px;\n        letter-spacing: -0.02em;\n        text-align: center;\n      }\n    }\n\n    .divider {\n      border-top: 1px solid #0000001a;\n      margin: 15px 0px;\n    }\n\n    .plan-benefits-icon {\n      color: #0084ff;\n      padding-right: 10px;\n      display: block;\n      padding-top: 4px;\n    }\n\n    .plan-benefits-icon .svg-inline--fa {\n      height: 20px;\n    }\n\n    .plan-benefits-text {\n      color: #141718;\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 24px;\n      letter-spacing: -0.01em;\n      text-align: left;\n    }\n  }\n\n  .plan-lock {\n    color: #0c923c;\n    margin-right: 10px;\n  }\n\n  .pay-resume {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .pay-resume-text {\n      font-size: 28px;\n      font-weight: 700;\n      line-height: 40px;\n    }\n  }\n\n  .no-margin-bottom {\n    margin-bottom: 0;\n  }\n\n  .promo-container {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .pay-promocode {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .button-link {\n      display: flex;\n      flex-direction: row-reverse;\n\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 24px;\n      letter-spacing: -0.02em;\n      text-align: right;\n      text-decoration: none;\n    }\n\n    .pay-resume-text {\n      font-size: 28px;\n      font-weight: 700;\n      line-height: 40px;\n    }\n  }\n\n  .pay-text {\n  \n    margin-bottom: 20px;\n    font-size: 11px;\n    width: 100% !important;\n    color: #B6B8B9;\n    padding: 20px;\n  }\n\n  .pay-btn {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .pay-btn button {\n    font-size: 15px;\n    font-weight: 600;\n    padding: 8px 20px;\n    border-radius: 12px;\n    width: 100%;\n    height: 52px;\n  }\n\n  .plan-lock-instruction {\n    color: #6c7275;\n    font-size: 12px;\n  }\n\n  .paymentinfo-option {\n    padding: 20px;\n    border-radius: 20px;\n    border: 1px solid #000;\n\n    &.best-option {\n      color: #fff;\n      background-color: #000;\n    }\n\n    .paymentinfo-periodicity {\n      font-style: normal;\n      font-weight: 700;\n      font-size: 28px;\n      line-height: 40px;\n      letter-spacing: -0.01em;\n      color: rgba(108, 114, 117, 0.5);\n    }\n\n    .popular-opt {\n      gap: 8px;\n      background: #ff97e8;\n      border-radius: 4px;\n      color: #141718;\n    }\n  }\n\n  .paymentinfo-opt {\n    list-style-type: none;\n  }\n\n  .periodicity-opt {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n  }\n}\n\n.item-plan {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  flex-direction: row;\n  margin-bottom: 4px;\n}\n\n.selected-plan .plan-name {\n  color: #139843;\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n}\n\n\n\n.mobile-plan-top{\n  background-image: url(\"../../Assets/Images/blue-bg.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center top;\n}\n\n.container{\n  --bs-gutter-x: 0 !important;\n}\n\n.mobile-view{\n\n}\n.mobile-view .plan-discriminator{\n  width: 90%;\n  margin: 0 auto !important;\n  padding: 0;\n  padding-top: 0 !important;\n}\n\n.mobile-view .plan-discriminator .item-plan{\n  display: none;\n}\n\n.mobile-view .plan-discriminator .plan-section{\n  margin: 4px auto;\n}\n.mobile-view .plan-discriminator .plan-section .plan-price{\n  color: #6c7275;\n  font-size: 14px;\n  margin-right: 6px;\n  font-weight: 400;\n}\n.mobile-view .plan-discriminator .plan-section .plan-periodicity{\n  color: #6c7275;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.mobile-view .plan-discriminator .selected-plan{\n  background-color: #141718;\n  border-radius:25px;\n  width: 100%;\n  display: flex;\n  padding: 10px 20px;\n  flex-direction: row;\n  justify-content:space-between;\n  align-items: center;\n}\n\n.mobile-view .plan-discriminator .plan-name{\n  background: url(\"../../Assets/Images/zap.svg\");\n  background-repeat: no-repeat;\n  background-size: 30px;\n  background-position: left;\n  color: #3FDD78;\n  padding-left: 40px;\n  font-size: 20px;\n}\n\n.mobile-view .plan-discriminator .selected-plan .rectangle{\n  background-color: #FF69B4;\n  color: #000;\n  border-radius: 20px;\n}\n.mobile-view .selected-plan-badge{\n  border: solid 1px #000;\n  padding: 4px 8px;\n  border-top-right-radius: 12px;\n  border-top-left-radius: 12px;\n  width: 120px;\n  text-align: center;\n  margin: -1px auto;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.payment-info .stripe-elements{\n  margin-top: 20px !important;\n}\n\n.mobile-view .payment-secured{\n  margin: 0px auto 10px auto;\n}\n\n.mobile-view .periodicity-opt{\n  display: flex;\n  align-content: center;\n  align-items: stretch;\n  justify-content: space-between;\n  flex-direction: row !important;\n}\n\n.mobile-view .periodicity-container .periodicity-pay-text{\n  display: flex;\n  flex-direction: row !important;\n  position: relative;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.mobile-view .periodicity-container{\n  padding: 10px !important;\n  position: relative;\n}\n\n.mobile-view .periodicity-container .periodicity-pay-text .periodicity-save{\n  background-color: #000;\n  font-size: 10px;\n  padding: 2px 6px;\n  color: #FEFEFE;\n  width: fit-content;\n  height: fit-content;\n}\n\n.mobile-view .periodicity-pay-specifics .price{\n  font-size: 20px;\n  font-weight: 600;\n  text-align: center;\n  color: #000;\n}\n\n.mobile-view .periodicity-pay-specifics .per-period{\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: #6F6F6F;\n}\n\n.mobile-view .form-control{\n  height: 52px;\n  border-radius: 12px;\n  border-color: #6F6F6F;\n}\n\nbody .mobile-view .form-control .__PrivateStripeElement{\n  top: 10px !important;\n}\n\n.mobile-view .pay-resume{\n  background-color: #DEEBFF;\n  text-align: center;\n  border-radius: 30px;\n  color: #000;\n  display: flex;\n  padding: 16px 20px;\n  justify-content: center;\n  align-items: center;\n  width: fit-content;\n  margin: 0 auto 20px;\n}\n\n.mobile-view .pay-resume .pay-resume-text{\n  color: #141718;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
